// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import CommentEditScreen from "../../src/screens/comments/edit-screen"
import ScreenTitle from "../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} CommentNewRouteProps */

/** @typedef {Record<string, never>} CommentNewRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<CommentNewRouteProps, CommentNewRouteState>}
 */
class CommentNewRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("New comment")}</ScreenTitle>
        <CommentEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<CommentNewRouteProps>} */
const CommentNewRouteComponent = memo(shapeComponent(CommentNewRoute))

export default CommentNewRouteComponent
